/**
 * @file contains helper functions for QuickFilters
 */
import { Location } from 'react-router-dom';

import { SearchQuery } from '../../generated/graphql';
import translate from '../../i18n/translate';
import {
  getSearchParamFilterHasDueDate,
  getSearchParamFilterMembers,
  getSearchParamFilterQuick,
} from '../../routes/helpers/searchParams';
import {
  getFilterMembersUrl,
  getHasDueDateQuickFilterUrl,
} from '../../routes/urls/searchParams/kanbanFilters';
import { getUserCurrent } from '../../utils/permissions/storage';

const hasDueDate = false;

/**
 * Check whether the members kanban quick filter is active
 *
 * @param location History location object
 * @returns        Whether it's true
 */
const getIsMembersQuickFilterActive = (location: Location): boolean => {
  return getSearchParamFilterMembers(location) !== null;
};

/**
 * Check whether the hasDueDate kanban quick filter is active
 *
 * @param location History location object
 * @returns        Whether it's true
 */
const getIsHasDueDateFilterActive = (location: Location): boolean => {
  return typeof getSearchParamFilterHasDueDate(location) === 'boolean';
};

/**
 * Check whether the feed quick filter is active
 *
 * @param location History location object
 * @param filterId Quick filter ID
 * @returns        Whether it's true
 */
export const getIsQuickFilterActive = (
  location: Location,
  filterId: SearchQuery['id'],
): boolean => {
  return getSearchParamFilterQuick(location) === filterId;
};

/**
 * Get quick filter properties we want to show on the kanban page
 *
 * @param location History location object
 * @returns        Kanban quick filters
 */
export const getKanbanQuickFilters = (location: Location) => {
  const isMembersFilterActive = getIsMembersQuickFilterActive(location);
  const isHasDueDateFilterActive = getIsHasDueDateFilterActive(location);
  const user = getUserCurrent();

  return [
    {
      isActive: isMembersFilterActive,
      label: translate('FILTER__ASSIGNED_TO_ME'),
      url: getFilterMembersUrl(location, isMembersFilterActive, user?.id),
    },
    {
      isActive: isHasDueDateFilterActive,
      label: translate('DUE_DATE__WITHOUT'),
      url: getHasDueDateQuickFilterUrl(
        location,
        isHasDueDateFilterActive,
        hasDueDate,
      ),
    },
  ];
};
